import firebase from '@/firebase/firestore';

export default {
  camNoteUpload(userId,projectId,title,description,category,selectedFile,isPrivate,GeoPoint){
    const db = firebase.firestore().collection("user").doc(userId)
    
    let addData = {
      noteId: this.generateUUID(),
      userId: userId,
      projectId: projectId,
      createdAt: new Date(),
      editedAt: null,
      category: category,
      title: title,
      description: description,
      contents: null,
      type: "img",
      isPrivate: isPrivate,
      geoPoint: GeoPoint,
    }
    
    // ストレージオブジェクト作成
    var storageRef = firebase.storage().ref();
    // ファイルのパスを設定
    var mountainsRef = storageRef.child(`${userId}/note_img/${addData.noteId}`);
    // ファイルを適用してファイルアップロード開始
    mountainsRef.put(selectedFile).then(snapshot => {
      snapshot.ref.getDownloadURL()
      .then(downloadURL => {
        // imageUrl = downloadURL;
        addData.contents = downloadURL;
        // addData.contents.push({ downloadURL });
        db.collection("notes").doc(addData.noteId).set(addData);
        console.log("note created!");
        alert('You created a note !');
      });
    });
  },
  txtNoteUpload(){},
  micNoteUpload(){},
  drawNoteUpload(){},
  deleteNote(userId, noteId){
    // Remove Project itself from projects collection
    const db = firebase.firestore().collection('user').doc(userId)
      .collection('notes').doc(noteId);
    db.delete().then(
      alert('You have deleted the project!' + noteId)
    );
  },
  generateUUID() {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  },
};